import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import {
  C_Button,
  Change_Button,
  Go_Button,
} from "../../components/Common/CommonButton";
import { C_DatePicker, C_ItemSelect, C_Select } from "../../CustomValidateForm";
import * as _cfunc from "../../components/Common/CommonFunction";
import { mode, pageId, url } from "../../routes/index";
import { MetaTags } from "react-meta-tags";
import {
  BreadcrumbShowCountlabel,
  GetVenderSupplierCustomer,
  GetVenderSupplierCustomerSuccess,
  commonPageField,
  commonPageFieldSuccess,
  getGroupList,
  getSubGroupList,
  getSubGroupListSuccess,
  get_Sub_Group_By_Group_ForDropDown,
  get_Sub_Group_By_Group_ForDropDown_Success,
} from "../../store/actions";
import {
  GetRoutesList,
  GetRoutesListSuccess,
} from "../../store/Administrator/RoutesRedux/actions";
import {
  getPartyTypelistSuccess,
} from "../../store/Administrator/PartyTypeRedux/action";
import {
  ItemSaleGoButton_API,
  ItemSaleGoButton_API_Success,
  Items_On_Group_And_Subgroup_API,
  Items_On_Group_And_Subgroup_API_Success,
  SupplierOnPartyType_API,
} from "../../store/Report/ItemSaleReport/action";
import "../ItemSaleReport/ItemSaleCSS.scss";
import { useMemo } from "react";
import * as initail from "./hardcodeDetails";
import { ItemSaleContext } from "./ContextDataProvider";
import {
  fetchDataAndSetDropdown,
} from "./SortAndExcelDownloadFunc";
import { ExcelReportComponent } from "../../components/Common/ReportCommonFunc/ExcelDownloadWithCSS";
import { allLabelWithZero } from "../../components/Common/CommonErrorMsg/HarderCodeData";

const HeaderSection = (props) => {
  const states = ItemSaleContext();

  const dispatch = useDispatch();
  const history = useHistory();
  const isSCMParty = _cfunc.loginIsSCMParty();
  const [channelFromOption, setChannelFromOption] = useState([]);
  const [channelToOption, setChannelToOption] = useState([]);
  const [excelLoading, setExcelLoading] = useState(false);
  const [expandedGroups, setExpandedGroups] = useState([]);
  const [productSearch, setProductSearch] = useState("");
  const [cascadeBusy, setCascadeBusy] = useState(false);
  const compactMulti = {
    menu: (p) => ({ ...p, zIndex: 5 }),
    control: (p) => ({ ...p, minHeight: "38px", maxHeight: "38px", flexWrap: "nowrap" }),
    valueContainer: (p) => ({ ...p, flexWrap: "nowrap", overflow: "hidden", maxHeight: "36px" }),
    multiValue: (p) => ({ ...p, flexShrink: 0, maxWidth: "100px" }),
    multiValueLabel: (p) => ({ ...p, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }),
  };
  const {
    goBtnLoading,
    ItemSaleReportGobtn,
    userAccess,
    supplierLoading,
    supplier,
    RoutesList,
    routesDropLoading,
    customerDropdown,
    customerDropLoading,
    ItemDropdownloading,
    ItemNameList,
    productLoading,
    productDropdown,
    subProductLoading,
    subProductDropdown,
    getSubProductbyProduct,
    supplierListOnPartyType,
  } = useSelector((state) => ({
    goBtnLoading: state.ItemSaleReportReducer.goBtnLoading,
    ItemSaleReportGobtn: state.ItemSaleReportReducer.ItemSaleReportGobtn,

    supplierLoading:
      state.CommonAPI_Reducer.SSDD_ListLoading ||
      state.ItemSaleReportReducer.supplierListLoading,

    supplier: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
    supplierListOnPartyType: state.ItemSaleReportReducer.supplierList,

    RoutesList: state.RoutesReducer.RoutesList,
    routesDropLoading: state.RoutesReducer.goBtnLoading,

    PartyTypes: state.PartyTypeReducer.ListData,

    customerDropdown: state.CommonAPI_Reducer.vendorSupplierCustomer,
    customerDropLoading: state.CommonAPI_Reducer.vendorSupplierCustomerLoading,

    ItemDropdownloading: state.ItemSaleReportReducer.itemListLoading,
    ItemNameList: state.ItemSaleReportReducer.itemList,

    productLoading: state.GroupReducer.goBtnLoading,
    productDropdown: state.GroupReducer.groupList,

    subProductLoading: state.SubGroupReducer.goBtnLoading,
    subProductDropdown: state.SubGroupReducer.SubgroupList,
    getSubProductbyProduct: state.ItemMastersReducer.SubGroupList,

    userAccess: state.Login.RoleAccessUpdateData,
  }));

  const { fromdate, todate } = states.hederFilters;
  const {
    subProductCache, setSubProductCache,
    subProductToProductMap, setSubProductToProductMap,
    itemCacheByProduct, setItemCacheByProduct,
    itemCacheBySubProduct, setItemCacheBySubProduct,
    resetCascadeCache,
  } = states;

  // --- refs that track cascade selection + one-at-a-time fetch queues ---
  const prevProductIdsRef = useRef([]);
  const prevSubProductIdsRef = useRef([]);
  const subProductQueueRef = useRef([]);
  const subProductFetchingIdRef = useRef(null);
  const itemQueueRef = useRef([]);
  const itemFetchingIdRef = useRef(null);

  function resetCascadeState() {
    resetCascadeCache();
    subProductQueueRef.current = [];
    subProductFetchingIdRef.current = null;
    itemQueueRef.current = [];
    itemFetchingIdRef.current = null;
    prevProductIdsRef.current = [];
    prevSubProductIdsRef.current = [];
  }

  function processSubProductQueue() {
    if (subProductFetchingIdRef.current !== null) return;
    const nextId = subProductQueueRef.current.shift();
    if (nextId === undefined) return;
    subProductFetchingIdRef.current = nextId;
    dispatch(get_Sub_Group_By_Group_ForDropDown(String(nextId)));
  }

  function processItemQueue() {
    if (itemFetchingIdRef.current !== null) return;
    const next = itemQueueRef.current.shift();
    if (!next) return;
    itemFetchingIdRef.current = next;
    dispatch(
      Items_On_Group_And_Subgroup_API({
        Group: next.type === "product" ? next.id : next.groupId,
        SubGroup: next.type === "product" ? 0 : next.id,
      })
    );
  }

  // true while any Sub Product / SKU call is running or still waiting in a queue
  function refreshCascadeBusy() {
    setCascadeBusy(
      subProductFetchingIdRef.current !== null ||
      subProductQueueRef.current.length > 0 ||
      itemFetchingIdRef.current !== null ||
      itemQueueRef.current.length > 0
    );
  }

  const location = { ...history.location };
  const hasShowModal = props.hasOwnProperty(mode.editValue);

  // userAccess useEffect
  useEffect(() => {
    let userAcc = null;
    let locationPath = location.pathname;
    if (hasShowModal) {
      locationPath = props.masterPath;
    }
    userAcc = userAccess.find((inx) => {
      return `/${inx.ActualPagePath}` === locationPath;
    });
    if (userAcc) {
      states.setUserAccState(userAcc);
      _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
    }
  }, [userAccess]);

  useEffect(() => {
    dispatch(commonPageFieldSuccess(null));
    dispatch(commonPageField(pageId.ITEM_SALE_REPORT));

    const jsonBody = JSON.stringify({
      CompanyID: _cfunc.loginCompanyID(),
      PartyID: _cfunc.loginSelectedPartyID(),
    });
    dispatch(GetRoutesList(jsonBody));
    dispatch(
      GetVenderSupplierCustomer({
        subPageMode: url.ITEM_SALE_REPORT,
        PartyID: _cfunc.loginSelectedPartyID(),
        RouteID: "",
      })
    );

    dispatch(getGroupList({ CompanyID: _cfunc.loginCompanyID() }));
    dispatch(getSubGroupList({ CompanyID: _cfunc.loginCompanyID() }));
    dispatch(Items_On_Group_And_Subgroup_API({ Group: 0, SubGroup: 0 }));
    dispatch(BreadcrumbShowCountlabel(`Count:0 currency_symbol 0`));
    if (_cfunc.CommonPartyDropValue().value > 0) {
      states.setSupplierSelect(_cfunc.CommonPartyDropValue())
    }
    return () => {
      dispatch(commonPageFieldSuccess(null));
      dispatch(getPartyTypelistSuccess([]));
      dispatch(ItemSaleGoButton_API_Success([]));
      resetCascadeState();
    };
  }, []);

  const channelFrom_WithAll = useMemo(() => {
    if (channelFromOption.length > 0) {
      return [allLabelWithZero, ...channelFromOption,];
    }
    return channelFromOption;
  }, [channelFromOption]);

  useEffect(async () => {
    fetchDataAndSetDropdown(0, setChannelFromOption); // set ChannelFrom dropdown (CompanyID is 0)
    fetchDataAndSetDropdown(_cfunc.loginCompanyID(), setChannelToOption); // set ChannelTo dropdown (CompanyID is loginCompanyID)
  }, []);

  useEffect(() => {
    if (ItemSaleReportGobtn.length > 0) {
      states.setInitaialBaseData(ItemSaleReportGobtn);
      dispatch(ItemSaleGoButton_API_Success([]));
      dataManpulationFunction(ItemSaleReportGobtn);
    }
  }, [ItemSaleReportGobtn]);

  // --- merged (union) Sub Product options from the per-product cache ---
  const subProductDropdownOptions = useMemo(() => {
    if (states.productSelect[0]?.value === 0) {
      return subProductDropdown.map((i) => ({ value: i.id, label: i.Name }));
    }
    const seen = new Set();
    const options = [];
    states.productSelect.forEach((p) => {
      (subProductCache[p.value] || []).forEach((opt) => {
        if (!seen.has(opt.value)) {
          seen.add(opt.value);
          options.push(opt);
        }
      });
    });
    return options;
  }, [states.productSelect, subProductDropdown, subProductCache]);

  // capture each single-id SubProduct API response into the cache, then advance the queue
  useEffect(() => {
    if (subProductFetchingIdRef.current === null) return;
    const productId = subProductFetchingIdRef.current;
    const options = getSubProductbyProduct.map((i) => ({ value: i.id, label: i.Name }));

    setSubProductCache((prev) => ({ ...prev, [productId]: options }));
    setSubProductToProductMap((prev) => {
      const updated = { ...prev };
      options.forEach((o) => { updated[o.value] = productId; });
      return updated;
    });

    subProductFetchingIdRef.current = null;
    processSubProductQueue();      // no Success([]) reset here, that reset caused the bug
    refreshCascadeBusy();
  }, [getSubProductbyProduct]);

  const supplierDropdownOptions = useMemo(() => {
    let options = [];
    if (states.channelFromSelect.value === 0) {
      options = supplier.map((i) => ({
        value: i.id,
        label: i.Name,
      }));
    } else {
      options = supplierListOnPartyType.map((i) => ({
        value: i.id,
        label: i.Name,
      }));
    }
    options.unshift(initail.INITIAL_ZERO);
    return options;
  }, [states.channelFromSelect, supplier, supplierListOnPartyType]);

  const generateOptions1 = (
    sourceArray,
    labelField = "Name",
    valueField = "id"
  ) => [
      ...sourceArray.map((item) => ({
        value: item[valueField],
        label: item[labelField],
      })),
    ];

  const routeDropdownOptions = useMemo(
    () => generateOptions1(RoutesList.filter((route) => route.IsActive)),
    [RoutesList]
  );

  // --- merged (union) Item options: driven by SubProduct selection if present, else Product ---
  const itemNameDropdownOptions = useMemo(() => {
    const hasSubProductFilter =
      states.subProductSelect.length > 0 && states.subProductSelect[0]?.value !== 0;
    const hasProductFilter =
      states.productSelect.length > 0 && states.productSelect[0]?.value !== 0;

    if (!hasProductFilter && !hasSubProductFilter) {
      return generateOptions1(ItemNameList);
    }

    const seen = new Set();
    const options = [];
    const source = hasSubProductFilter ? states.subProductSelect : states.productSelect;
    const cache = hasSubProductFilter ? itemCacheBySubProduct : itemCacheByProduct;

    source.forEach((sel) => {
      (cache[sel.value] || []).forEach((opt) => {
        if (!seen.has(opt.value)) {
          seen.add(opt.value);
          options.push(opt);
        }
      });
    });
    return options;
  }, [states.productSelect, states.subProductSelect, itemCacheByProduct, itemCacheBySubProduct, ItemNameList]);

  // capture each single-id Item API response into the correct cache, then advance the queue
  useEffect(() => {
    if (itemFetchingIdRef.current === null) return;
    const request = itemFetchingIdRef.current;
    const options = ItemNameList.map((i) => ({ value: i.id, label: i.Name }));

    if (request.type === "product") {
      setItemCacheByProduct((prev) => ({ ...prev, [request.id]: options }));
    } else {
      setItemCacheBySubProduct((prev) => ({ ...prev, [request.id]: options }));
    }

    itemFetchingIdRef.current = null;
    processItemQueue();            // no Success([]) reset here either
    refreshCascadeBusy();
  }, [ItemNameList]);

  useEffect(() => {
    if (!cascadeBusy) return;
    const t = setTimeout(() => {
      subProductQueueRef.current = [];
      subProductFetchingIdRef.current = null;
      itemQueueRef.current = [];
      itemFetchingIdRef.current = null;
      setCascadeBusy(false);
    }, 30000);
    return () => clearTimeout(t);
  }, [cascadeBusy, getSubProductbyProduct, ItemNameList]);

  const productDropdownOptions = useMemo(() => {
    const groups = new Map();

    productDropdown.forEach((i) => {
      if (!groups.has(i.GroupTypeName)) {
        groups.set(i.GroupTypeName, []);
      }

      groups.get(i.GroupTypeName).push({
        value: i.id,
        label: i.Name,
        productName: i.Name,
        groupType: i.GroupTypeName,
        groupTypeId: i.GroupType,
      });
    });

    return Array.from(groups, ([label, options]) => ({
      label,
      options,
    }));
  }, [productDropdown]);

  const selectedProductIds = useMemo(
    () => new Set(states.productSelect.filter((p) => p.value > 0).map((p) => p.value)),
    [states.productSelect]
  );

  const isGroupFullySelected = (group) =>
    group.options.length > 0 && group.options.every((o) => selectedProductIds.has(o.value));

  // value shown in the box: a fully selected group becomes ONE chip with the group name
  const productSelectDisplay = useMemo(() => {
    if (states.productSelect[0]?.value === 0) return states.productSelect;   // "All"
    const fullGroups = productDropdownOptions.filter(isGroupFullySelected);
    const fullNames = new Set(fullGroups.map((g) => g.label));
    return [
      ...fullGroups.map((g) => ({ value: `group-${g.label}`, label: g.label, isGroup: true })),
      ...states.productSelect.filter((p) => !fullNames.has(p.groupType)),
    ];
  }, [states.productSelect, productDropdownOptions, selectedProductIds]);

  // group type that already has a selection (null = nothing selected / "All")
  const activeGroupType = useMemo(
    () => states.productSelect.find((p) => p.value > 0)?.groupType || null,
    [states.productSelect]
  );
  const isGroupLocked = (groupLabel) => !!activeGroupType && groupLabel !== activeGroupType;

  function toggleGroupSelect(groupLabel) {
    if (isGroupLocked(groupLabel)) return;
    const group = productDropdownOptions.find((g) => g.label === groupLabel);
    if (!group) return;
    const current = states.productSelect.filter((p) => p.value > 0);
    const next = isGroupFullySelected(group)
      ? current.filter((p) => p.groupType !== groupLabel)
      : [...current, ...group.options.filter((o) => !selectedProductIds.has(o.value))];
    ProductOnchange(next);
  }

  function ProductSelectChange(e, meta) {
    // clicking an already-selected option in the menu = deselect only that product
    if (meta?.action === "deselect-option" && meta.option) {
      ProductOnchange(
        states.productSelect.filter((p) => p.value > 0 && p.value !== meta.option.value)
      );
      return;
    }
    // otherwise turn group chips back into their products
    const real = [];
    const seen = new Set();
    (e || []).forEach((item) => {
      const items = item.isGroup
        ? productDropdownOptions.find((g) => g.label === item.label)?.options || []
        : [item];
      items.forEach((o) => {
        if (!seen.has(o.value)) { seen.add(o.value); real.push(o); }
      });
    });
    ProductOnchange(real);
  }


  const customerDropdownOptions = useMemo(
    () => generateOptions1(customerDropdown),
    [customerDropdown]
  );

  function fromdateOnchange(e, date) {
    states.setTableData([]);
    dispatch(ItemSaleGoButton_API_Success([]));
    let newObj = { ...states.hederFilters };
    newObj.fromdate = date;
    states.setHederFilters(newObj);
    states.setInitaialBaseData([]);
  }

  function todateOnchange(e, date) {
    states.setTableData([]);
    dispatch(ItemSaleGoButton_API_Success([]));
    let newObj = { ...states.hederFilters };
    newObj.todate = date;
    states.setHederFilters(newObj);
    states.setInitaialBaseData([]);
  }

  function ChannelFromDropdown_Onchange(e) {
    dispatch(ItemSaleGoButton_API_Success([]));
    states.setTableData([]);
    states.setChannelFromSelect(e);
    states.setSupplierSelect(initail.INITIAL_ZERO);
    dispatch(
      SupplierOnPartyType_API({
        employeeID: _cfunc.loginEmployeeID(),
        channelFromID: e.value,
      })
    );
  }

  function SupplierOnChange(event) {
    dispatch(ItemSaleGoButton_API_Success([]));
    states.setTableData([]);
    states.setSupplierSelect(event);
    states.setRouteSelect([allLabelWithZero]);
    states.setCustomerSelect([allLabelWithZero]);
    states.setInitaialBaseData([]);
    dispatch(GetVenderSupplierCustomerSuccess([]));
    dispatch(GetRoutesListSuccess([]));
    if (event.value > 0) {
      dispatch(
        GetVenderSupplierCustomer({
          subPageMode: url.ITEM_SALE_REPORT,
          PartyID: event.value,
          RouteID: "",
        })
      );
      const jsonBody = JSON.stringify({
        CompanyID: _cfunc.loginCompanyID(),
        PartyID: event.value,
      });
      dispatch(GetRoutesList(jsonBody));
    }
  }

  function ChannelToOnchange(e = []) {
    if (e.length === 0) {
      e = [allLabelWithZero];
    } else {
      e = e.filter((i) => i.value > 0);
    }
    states.setChannelToSelect(e);
  }

  function RouteOnChange(e = []) {
    states.setCustomerSelect([allLabelWithZero]);
    dispatch(GetVenderSupplierCustomerSuccess([]));

    if (e.length === 0) {
      e = [allLabelWithZero];
      dispatch(
        GetVenderSupplierCustomer({
          subPageMode: url.ITEM_SALE_REPORT,
          RouteID: "",
          PartyID: states.supplierSelect.value,
        })
      );
    } else {
      e = e.filter((i) => i.value > 0);
      if (e.length === 1) {
        dispatch(
          GetVenderSupplierCustomer({
            subPageMode: url.ITEM_SALE_REPORT,
            RouteID: e[0].value,
            PartyID: states.supplierSelect.value,
          })
        );
      } else {
        states.setCustomerSelect(initail.INITIAL_ARRAY);
        dispatch(GetVenderSupplierCustomerSuccess([]));
      }
    }
    states.setRouteSelect(e);
  }

  function CustomerOnChange(e = []) {
    if (e.length === 0) {
      e = [allLabelWithZero];
    } else {
      e = e.filter((i) => i.value > 0);
    }
    states.setCustomerSelect(e);
  }

  // --- Product change: fetch each newly added id one at a time, drop cache for removed ids ---
  function ProductOnchange(e = []) {
    states.setSubProductSelect(initail.INITIAL_ARRAY);
    states.setItemNameSelect(initail.INITIAL_ARRAY);
    prevSubProductIdsRef.current = [];

    const newSelection = e.length === 0 ? [] : e.filter((i) => i.value > 0);

    if (newSelection.length === 0) {
      resetCascadeState();
      setCascadeBusy(false);
      dispatch(getSubGroupListSuccess([]));
      dispatch(get_Sub_Group_By_Group_ForDropDown_Success([]));
      dispatch(Items_On_Group_And_Subgroup_API_Success([]));
      dispatch(getGroupList({ CompanyID: _cfunc.loginCompanyID() }));
      dispatch(getSubGroupList({ CompanyID: _cfunc.loginCompanyID() }));
      dispatch(Items_On_Group_And_Subgroup_API({ Group: 0, SubGroup: 0 }));
      states.setProductSelect([allLabelWithZero]);
      return;
    }

    const prevIds = prevProductIdsRef.current;
    const newIds = newSelection.map((i) => i.value);
    const addedIds = newIds.filter((id) => !prevIds.includes(id));
    const removedIds = prevIds.filter((id) => !newIds.includes(id));

    // MINUS — drop cache for deselected products, no API call
    if (removedIds.length > 0) {
      setSubProductCache((prev) => {
        const updated = { ...prev };
        removedIds.forEach((id) => delete updated[id]);
        return updated;
      });
      setItemCacheByProduct((prev) => {
        const updated = { ...prev };
        removedIds.forEach((id) => delete updated[id]);
        return updated;
      });
      subProductQueueRef.current = subProductQueueRef.current.filter(
        (id) => !removedIds.includes(id)
      );
      itemQueueRef.current = itemQueueRef.current.filter(
        (r) => !(r.type === "product" && removedIds.includes(r.id))
      );
    }

    // BIND — fetch each newly added product id one at a time, then merge into cache
    addedIds.forEach((id) => {
      subProductQueueRef.current.push(id);
      itemQueueRef.current.push({ type: "product", id });
    });
    processSubProductQueue();
    processItemQueue();
    refreshCascadeBusy();
    prevProductIdsRef.current = newIds;
    states.setProductSelect(newSelection);
  }

  // --- Sub Product change: same add/remove pattern, one id at a time ---
  function Sub_ProductOnChange(e = []) {
    states.setItemNameSelect(initail.INITIAL_ARRAY);

    const newSelection = e.length === 0 ? [] : e.filter((i) => i.value > 0);

    const prevIds = prevSubProductIdsRef.current;
    const newIds = newSelection.map((i) => i.value);
    const addedIds = newIds.filter((id) => !prevIds.includes(id));
    const removedIds = prevIds.filter((id) => !newIds.includes(id));

    // MINUS — drop cache for deselected sub products, no API call
    if (removedIds.length > 0) {
      setItemCacheBySubProduct((prev) => {
        const updated = { ...prev };
        removedIds.forEach((id) => delete updated[id]);
        return updated;
      });
      itemQueueRef.current = itemQueueRef.current.filter(
        (r) => !(r.type === "subproduct" && removedIds.includes(r.id))
      );
    }

    // BIND — fetch each newly added sub product id one at a time
    addedIds.forEach((id) => {
      const groupId = subProductToProductMap[id];
      if (groupId !== undefined) {
        itemQueueRef.current.push({ type: "subproduct", id, groupId });
      }
    });
    processItemQueue();
    refreshCascadeBusy();
    prevSubProductIdsRef.current = newIds;
    states.setSubProductSelect(newSelection.length === 0 ? [allLabelWithZero] : newSelection);
  }

  function ItemOnChange(e = []) {
    if (e.length === 0) {
      e = [allLabelWithZero];
    } else {
      e = e.filter((i) => i.value > 0);
    }
    states.setItemNameSelect(e);
  }

  function showAlsoOnChange(event) {
    let isLastInvoice =
      event.length > 0
        ? [1, 5, 6, 7, 9, 10, 11, 12].includes(event[event.length - 1].value)
        : false;

    if (isLastInvoice) {
      if (!event.some((item) => item.value === 1)) {
        event.push(initail.SHOW_ALSO_OPTIONS[0]);
      }
    }

    if (event.some((item) => [2, 4].includes(item.value))) {
      if (!event.some((item) => item.value === 4)) {
        event.push(initail.SHOW_ALSO_OPTIONS[3]);
      }
    }
    if (event.some((item) => item.value === 8)) {
      states.setItemNameCheckbox(true);
    } else {
      states.setItemNameCheckbox(false);
    }

    states.setShowAlsoSelect(event);
  }

  function goButtonHandler() {

    try {
      const jsonBody = JSON.stringify({
        FromDate: fromdate,
        ToDate: todate,
        PartyType: states.supplierSelect.value > 0 ? 0 : states.channelFromSelect.value,
        Party: !isSCMParty ? _cfunc.loginSelectedPartyID() : states.supplierSelect.value,
        Employee: !isSCMParty ? 0 : _cfunc.loginEmployeeID(),
        ItemID: states.itemNameSelect.map(inx => inx.value).join(','),
        CompanyID: _cfunc.loginCompanyID(),
        Group_Type:
          states.productSelect.find((item) => item.value > 0)?.groupTypeId ?? 0,

      });
      dispatch(ItemSaleGoButton_API({ jsonBody, btnId: url.ITEM_SALE_REPORT }));
    } catch (error) {
      _cfunc.CommonConsole(error);
    }
  }

  function change_ButtonHandler(e) {
    dispatch(ItemSaleGoButton_API_Success([]));
    states.setTableData([]);
    states.setInitaialBaseData([]);
    resetCascadeState();
    setCascadeBusy(false);
    dispatch(BreadcrumbShowCountlabel(`Count:0 currency_symbol 0`));
  }

  const dataManpulationFunction = async (baseData) => {

    const {
      selectedColumns = [{}],
      manupulatedData = [],
      totalAmount,
    } = await states.sortManipulationFunc(baseData);
    states.setSelectedColumns(selectedColumns);
    states.setTableData(manupulatedData);
    return { selectedColumns, manupulatedData, totalAmount };
  };

  async function ExcelDownload() {
    setExcelLoading(true);
    const { selectedColumns, manupulatedData } = await dataManpulationFunction(states.initaialBaseData);
    ExcelReportComponent({
      excelTableData: manupulatedData,
      excelFileName: 'Item Sale Report',
      customKeyColumns: { tableData: selectedColumns, isButton: false },
    });
    setExcelLoading(false);
  }

  return (
    <React.Fragment>
      <MetaTags>{_cfunc.metaTagLabel(states.userPageAccessState)}</MetaTags>

      <div>
        <div className="item-Sale-card_1 px-2 text-black mt-n1 px-2  mb-1 c_card_filter text-black ">
          <Row>
            <Col className="col col-11  mt-1">
              <Row className="mb-2 row ">
                <Col sm={3}>
                  <FormGroup className="mb-n2 row mt-1">
                    <Input
                      style={{ marginLeft: "5px", marginTop: "10px" }}
                      className="p-1"
                      id="fromdate"
                      type="checkbox"
                      checked={states.fromDateCheckbox}
                      onClick={(e) => {
                        states.setFromDateCheckbox(e.target.checked);
                      }}
                    />
                    <Label className="col-sm-3 p-2">FromDate</Label>
                    <Col sm={6}>
                      <C_DatePicker
                        name="FromDate"
                        value={fromdate}
                        disabled={states.tableData.length > 0 && true}
                        onChange={fromdateOnchange}
                      />
                    </Col>
                  </FormGroup>
                </Col>

                <Col sm={3} className="custom-to-date-col">
                  <FormGroup className="mb-n3 row mt-1">
                    <div
                      style={{
                        marginLeft: "1px",
                        marginTop: "10px",
                        width: "5px",
                      }}
                    ></div>
                    <Label className="col-sm-4 p-2">ToDate</Label>
                    <Col>
                      <C_DatePicker
                        name="ToDate"
                        value={todate}
                        disabled={states.tableData.length > 0 && true}
                        onChange={todateOnchange}
                      />
                    </Col>
                  </FormGroup>
                </Col>

                <Col sm={3}>
                  <FormGroup className="mb-n3 row mt-1">
                    <Input
                      style={{ marginLeft: "5px", marginTop: "10px" }}
                      className="p-1"
                      type="checkbox"
                      id="channelFrom"
                      checked={states.channelFromCheckbox}
                      onChange={(e) => {
                        states.setChannelFromCheckbox(e.target.checked);
                      }}
                    />
                    <Label className="col-sm-4 p-2">Channel From</Label>
                    <Col>
                      <C_Select
                        value={states.channelFromSelect}
                        isSearchable={true}
                        className="react-dropdown"
                        classNamePrefix="dropdown"
                        isDisabled={
                          (states.tableData.length > 0 || !isSCMParty) && true
                        }
                        styles={{
                          menu: (provided) => ({ ...provided, zIndex: 2 }),
                        }}
                        options={channelFrom_WithAll}
                        onChange={ChannelFromDropdown_Onchange}
                      />
                    </Col>
                  </FormGroup>
                </Col>

                <Col sm={3}>
                  <FormGroup className="mb-n3 row mt-1">
                    <Input
                      style={{ marginLeft: "5px", marginTop: "10px" }}
                      className="p-1"
                      type="checkbox"
                      id="supplier"
                      checked={states.supplierCheckbox}
                      onChange={(e) => {
                        states.setSupplierCheckbox(e.target.checked);
                      }}
                    />
                    <Label className="col-sm-4 p-2">Supplier</Label>
                    <Col>
                      <C_Select
                        value={
                          !isSCMParty
                            ? { label: _cfunc.loginPartyName() }
                            : states.supplierSelect
                        }
                        isSearchable={true}
                        isLoading={supplierLoading}
                        className="react-dropdown"
                        classNamePrefix="dropdown"
                        isDisabled={
                          (states.tableData.length > 0 || !isSCMParty) && true
                        }
                        styles={{
                          menu: (provided) => ({ ...provided, zIndex: 2 }),
                        }}
                        options={supplierDropdownOptions}
                        onChange={SupplierOnChange}
                      />
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
            </Col>

            <Col sm="1" className="mt-2 mb-1 ">
              {!(states.initaialBaseData.length > 0) ? (
                <Go_Button loading={goBtnLoading} onClick={goButtonHandler} />
              ) : (
                <Change_Button onClick={change_ButtonHandler} />
              )}
            </Col>
          </Row>
        </div>
        {!states.pivotMode && (
          <div className="item-Sale-card_3 px-2 text-black mt-1 mb-1" >
            <Row className="mb-1 ">
              <Col className="col col-11">
                <Row className="mt-1 ">
                  <Col sm={3}>
                    <FormGroup className=" row mt-1">
                      <Input
                        style={{ marginLeft: "5px", marginTop: "10px" }}
                        className="p-1"
                        type="checkbox"
                        checked={states.channelToCheckbox}
                        onChange={(e) => {
                          states.setChannelToCheckbox(e.target.checked);
                        }}
                      />
                      <Label className="col-sm-3 p-2">Channel to</Label>
                      <Col sm={7}>
                        <C_Select
                          value={states.channelToSelect}
                          isSearchable={true}
                          className="react-dropdown"
                          classNamePrefix="dropdown"
                          isMulti={true}
                          styles={{
                            menu: (provided) => ({ ...provided, zIndex: 2 }),
                          }}
                          options={channelToOption}
                          onChange={(e) => {
                            ChannelToOnchange(e);
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </Col>

                  <Col sm={3}>
                    <FormGroup className=" row mt-1">
                      <Input
                        style={{ marginLeft: "5px", marginTop: "10px" }}
                        className="p-1"
                        type="checkbox"
                        checked={states.routeCheckbox}
                        onChange={(e) => {
                          states.setRouteCheckbox(e.target.checked);
                        }}
                      />
                      <Label className="col-sm-4 p-2">Route</Label>
                      <Col>
                        <C_Select
                          classNamePrefix="react-select"
                          value={states.routeSelect}
                          options={routeDropdownOptions}
                          onChange={(e) => { RouteOnChange(e); }}
                          isMulti={true}
                          isLoading={routesDropLoading}
                          styles={{
                            menu: (provided) => ({ ...provided, zIndex: 2 }),
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </Col>

                  <Col sm={3}>
                    <FormGroup className=" row mt-1">
                      <Input
                        style={{ marginLeft: "5px", marginTop: "10px" }}
                        className="p-1"
                        type="checkbox"
                        checked={states.customerCheckbox}
                        onChange={(e) => {
                          states.setCustomerCheckbox(e.target.checked);
                        }}
                      />
                      <Label className="col-sm-4 p-2">Customer</Label>

                      <Col>
                        <C_Select
                          value={states.customerSelect}
                          isSearchable={true}
                          isLoading={customerDropLoading}
                          isMulti={true}
                          className="react-dropdown"
                          classNamePrefix="dropdown"
                          styles={{
                            menu: (provided) => ({ ...provided, zIndex: 2 }),
                          }}
                          options={customerDropdownOptions}
                          onChange={(e) => {
                            CustomerOnChange(e);
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </Col>

                  <Col sm={3}>
                    <FormGroup className=" row mt-1">
                      <div
                        style={{
                          marginLeft: "1px",
                          marginTop: "10px",
                          width: "5px",
                        }}
                      ></div>
                      <Label className="col-sm-4 p-2">Show Also</Label>

                      <Col>
                        <C_Select
                          value={states.showAlsoSelect}
                          isSearchable={true}
                          isMulti={true}
                          className="react-dropdown"
                          classNamePrefix="dropdown"
                          styles={{
                            menu: (provided) => ({ ...provided, zIndex: 2 }),
                          }}
                          options={initail.SHOW_ALSO_OPTIONS}
                          onChange={showAlsoOnChange}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>

              <Col sm="1" className="mt-2 mb-1 ">
                {states.initaialBaseData.length > 0 && (
                  <>
                    <samp>
                      <C_Button
                        type="button"
                        className="btn btn-success border-1 font-size-12 text-center"
                        onClick={() => {
                          dataManpulationFunction(states.initaialBaseData);
                        }}
                      >
                        <span
                          className="font-weight-bold"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          {" "}
                          Sort
                        </span>
                      </C_Button>
                    </samp>
                    <samp style={{ paddingLeft: "8px" }}>
                      <C_Button
                        type="button"
                        title="Download List"
                        spinnerColor={"white"}
                        loading={excelLoading}
                        className="btn btn-sm btn-outline-primary "
                        onClick={ExcelDownload}
                      >
                        <i className="bx bx-download font-size-14"></i>
                      </C_Button>
                    </samp>
                  </>
                )}
              </Col>
            </Row>

            <Row>
              <Col className="col col-11">
                <Row>
                  <Col sm={3}>
                    <FormGroup className=" row mt-2">
                      <Input
                        style={{ marginLeft: "5px", marginTop: "10px" }}
                        className="p-1"
                        type="checkbox"
                        checked={states.productCheckbox}
                        onChange={(e) => {
                          states.setProductCheckbox(e.target.checked);
                        }}
                      />
                      <Label className="col-sm-3 p-2">Product</Label>
                      <Col sm={7}>
                        <C_Select
                          value={productSelectDisplay}
                          isSearchable={true}
                          isLoading={productLoading || cascadeBusy}
                          isDisabled={cascadeBusy || ItemDropdownloading || productLoading}
                          isMulti={true}
                          closeMenuOnSelect={false}
                          className="react-dropdown"
                          classNamePrefix="dropdown"
                          options={productDropdownOptions}
                          hideSelectedOptions={false}
                          isOptionDisabled={(opt) => !!activeGroupType && opt.groupType !== activeGroupType}
                          onChange={ProductSelectChange}
                          isOptionSelected={(opt) => selectedProductIds.has(opt.value)}
                          onInputChange={(text) => { setProductSearch(text); return text; }}
                          onMenuClose={() => setProductSearch("")}
                          filterOption={(opt, input) =>
                            `${opt.data.groupType || ""} ${opt.data.productName || opt.label}`
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          styles={{
                            menu: (p) => ({ ...p, zIndex: 2, width: "200px", minWidth: "100%", borderRadius: "8px", overflow: "hidden", boxShadow: "0 6px 20px rgba(0,0,0,0.12)" }),
                            menuList: (p) => ({ ...p, padding: "6px", maxHeight: "340px" }),
                            group: (p) => ({ ...p, padding: 0, marginBottom: "4px" }),
                            groupHeading: (p) => ({ ...p, margin: 0, padding: 0, textTransform: "none" }),
                            option: (p, state) =>
                              !productSearch && (!expandedGroups.includes(state.data.groupType) || isGroupLocked(state.data.groupType))
                                ? { ...p, display: "none" }
                                : {
                                  ...p,
                                  padding: "8px 12px 8px 30px",
                                  fontSize: "13px",
                                  borderRadius: "6px",
                                  margin: "1px 0",
                                  color: "#343a40",
                                  opacity: state.isDisabled ? 0.4 : 1,
                                  cursor: state.isDisabled ? "not-allowed" : "pointer",
                                  backgroundColor: state.isSelected ? "#dfe3f8" : state.isFocused ? "#eef0fb" : "transparent",
                                  ":active": { backgroundColor: "#e2e6f8" },
                                },
                            multiValue: (p) => ({ ...p, borderRadius: "4px" }),
                            multiValueLabel: (p) => ({
                              ...p,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "110px",   // change this to show more or fewer characters
                            }),
                          }}
                          formatGroupLabel={(group) => {
                            const locked = isGroupLocked(group.label);
                            const open = !locked && (!!productSearch || expandedGroups.includes(group.label));   // a locked group never shows as open
                            const allSelected = isGroupFullySelected(group);
                            const someSelected = !allSelected && group.options.some((o) => selectedProductIds.has(o.value));
                            return (
                              <div
                                title={locked ? `Clear ${activeGroupType} to select from ${group.label}` : ""}
                                style={{
                                  backgroundColor: allSelected ? "#a9acdf" : "#d4d4ebf5",
                                  opacity: locked ? 0.5 : 1,
                                  cursor: locked ? "not-allowed" : "pointer",     // same cursor as the disabled checkbox, on the whole heading
                                  padding: "3px 8px",
                                  borderRadius: "4px",
                                  fontWeight: "bold",
                                  fontSize: "12px",
                                  color: "black",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  whiteSpace: "nowrap",
                                }}
                                onClick={() => {
                                  if (locked) return;                              // locked group: accordion does not open or close
                                  setExpandedGroups((prev) =>
                                    prev.includes(group.label) ? prev.filter((g) => g !== group.label) : [...prev, group.label]
                                  );
                                }}
                              >
                                <span className="d-flex align-items-center">
                                  <input
                                    type="checkbox"
                                    className="me-2"
                                    style={{ cursor: locked ? "not-allowed" : "pointer" }}
                                    checked={allSelected}
                                    disabled={locked}
                                    ref={(el) => { if (el) el.indeterminate = someSelected; }}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={() => toggleGroupSelect(group.label)}
                                  />
                                  {group.label}
                                </span>
                                <i className={open ? "fas fa-angle-up" : "fas fa-angle-down"} style={{ padding: "0 6px" }} />
                              </div>
                            );
                          }}
                          formatOptionLabel={(option, { context }) => {
                            if (option.isGroup) {
                              return <span title={`All ${option.label} products`}>{option.label}</span>;
                            }
                            if (context === "value" && option.groupType) {
                              return (
                                <span title={`${option.groupType} - ${option.productName}`}>
                                  {option.groupType} - {option.productName}
                                </span>
                              );
                            }
                            return (
                              <span>
                                {selectedProductIds.has(option.value) && <i className="fas fa-check me-1" />}
                                {option.productName || option.label}
                              </span>
                            );
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </Col>

                  <Col sm={3}>
                    <FormGroup className=" row mt-2">
                      <Input
                        style={{ marginLeft: "5px", marginTop: "10px" }}
                        className="p-1"
                        type="checkbox"
                        checked={states.subProductCheckbox}
                        onChange={(e) => {
                          states.setSubProductCheckbox(e.target.checked);
                        }}
                      />
                      <Label className="col-sm-4 p-2">Sub Product</Label>
                      <Col>
                        <C_Select
                          value={states.subProductSelect}
                          isSearchable={true}
                          isMulti={true}
                          isLoading={subProductLoading || cascadeBusy}
                          isDisabled={cascadeBusy}
                          className="react-dropdown"
                          classNamePrefix="dropdown"
                          styles={{
                            menu: (provided) => ({ ...provided, zIndex: 2 }),
                          }}
                          options={subProductDropdownOptions}
                          onChange={(e) => {
                            Sub_ProductOnChange(e);
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </Col>

                  <Col sm={3}>
                    <FormGroup className=" row mt-2">
                      <Input
                        style={{ marginLeft: "5px", marginTop: "10px" }}
                        className="p-1"
                        type="checkbox"
                        checked={states.itemNameCheckbox}
                        disabled={states.showAlsoSelect.some((i) => i.value === 8) && true}
                        onChange={(e) => {
                          states.setItemNameCheckbox(e.target.checked);
                        }}
                      />
                      <Label className="col-sm-4 p-2">SKU Name</Label>
                      <Col>
                        <C_Select
                          value={states.itemNameSelect}
                          isSearchable={true}
                          isMulti={true}
                          isLoading={ItemDropdownloading || cascadeBusy}
                          isDisabled={cascadeBusy}
                          className="react-dropdown"
                          classNamePrefix="dropdown"
                          styles={{
                            menu: (provided) => ({ ...provided, zIndex: 2 }),
                          }}
                          options={itemNameDropdownOptions}
                          onChange={(e) => {
                            ItemOnChange(e);
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </Col>

                  <Col sm={3}>
                    <FormGroup className=" row mt-2">
                      <div
                        style={{
                          marginLeft: "1px",
                          marginTop: "10px",
                          width: "5px",
                        }}
                      ></div>
                      <Label className="col-sm-4 p-2">Quantity</Label>
                      <Col>
                        <C_Select
                          value={states.unitDropdownSelect}
                          isSearchable={true}
                          className="react-dropdown"
                          classNamePrefix="dropdown"
                          styles={{ menu: (provided) => ({ ...provided, zIndex: 2 }) }}
                          options={initail.UNIT_DROPDOWN_OPTIONS}
                          onChange={(e) => {
                            states.setUnitDropdownSelect(e);
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>

              <Col sm="1" className="mt-2 mb-1">
                {states.initaialBaseData.length > 0 && (
                  <C_Button
                    type="button"
                    className="btn btn-warning border-1 font-size-12 text-center"
                    onClick={() => states.setPivotMode((pre) => !pre)}
                  >
                    <span
                      className="font-weight-bold"
                      style={{
                        fontWeight: "bold",
                        fontSize: "14px",
                        color: "black",
                      }}
                    >
                      Pivot
                    </span>
                  </C_Button>
                )}
              </Col>
            </Row>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default HeaderSection;